import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { brands, detectBrandFromHostname } from '../config/brands';

const BrandContext = createContext();

export const BrandProvider = ({ children }) => {
  const [brand, setBrandState] = useState(() => detectBrandFromHostname());

  const brandConfig = brands[brand] || brands.fastestform;

  // Apply brand CSS class to <html> for CSS variable switching
  useEffect(() => {
    const root = document.documentElement;
    // Remove all brand classes
    Object.keys(brands).forEach(b => {
      root.classList.remove(`brand-${b}`);
    });
    // Add current brand class (fastestform uses :root defaults, no class needed)
    if (brand !== 'fastestform') {
      root.classList.add(`brand-${brand}`);
    }
  }, [brand]);

  const setBrand = useCallback((newBrand) => {
    if (brands[newBrand]) {
      setBrandState(newBrand);
    }
  }, []);

  return (
    <BrandContext.Provider value={{ brand, setBrand, brandConfig }}>
      {children}
    </BrandContext.Provider>
  );
};

export const useBrand = () => {
  const context = useContext(BrandContext);
  if (!context) {
    throw new Error('useBrand must be used within a BrandProvider');
  }
  return context;
};
